import { useCallback } from "react";

import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";

export const useEmbedAwareOpenUrl = () => {
  const { isEmbedded } = useCommentsConfig();

  return useCallback(
    (url: string) => {
      if (isEmbedded) {
        window.open(url, "_blank", "noreferrer");
      } else {
        window.location.href = url;
      }
    },
    [isEmbedded],
  );
};
